import * as tslib_1 from "tslib";
import { call, put, select } from 'redux-saga/effects';
import { actions } from '../../Stream';
import { getCurrentMediaSource, getCurrentSubfolderId } from '../selectors';
import { getGallectionStreamId, getGallectionTypeFromMediaSourceType, } from '../helpers';
import { unsetCurrentSubfolderId } from '../actions';
import { request } from '../../xhr';
function removeGallection(action) {
    var folderId, mediaSource, currentSubfolderId, streamId;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                folderId = action.payload;
                return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                mediaSource = _a.sent();
                return [4 /*yield*/, select(getCurrentSubfolderId)];
            case 2:
                currentSubfolderId = _a.sent();
                streamId = getGallectionStreamId(mediaSource);
                return [4 /*yield*/, put(actions.deleteItem({ streamId: streamId, item: folderId }))];
            case 3:
                _a.sent();
                if (!(folderId === currentSubfolderId)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(unsetCurrentSubfolderId())];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: 'gallection/folders/delete',
                    data: {
                        type: getGallectionTypeFromMediaSourceType(mediaSource),
                        folderid: folderId,
                    },
                })];
            case 6:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default removeGallection;
//# sourceMappingURL=removeGallection.js.map